<template>
  <!-- Without its button it is only the confirmation: no floating box, which empty showed as a white
       pill over the phone list. -->
  <div :class="{ 'keywords-status-manager': hasButton }">
    <BaseRoundButton
      v-if="hasButton"
      @click.native="onDeleteKeywords()"
      :tooltip-text="$t('actions.delete')"
      class="keywords-status-manager__item"
      icon="trash-2"
      is-red
      is-white
    />
    <DeleteDialog ref="deleteKeywordsDialog" @execute="deleteKeywords" :buttonText="$t('actions.delete')">
      <template slot="content">
        <div class="page-keywords__delete-category">
          {{ $t('page.admin-keywords.delete-keyword') }}
          <div class="keywords-status-manager__delete-list">
            <Keyword v-for="(kw, index) in keywords" :key="index">
              {{ kw.value }}
            </Keyword>
          </div>
          <div class="page-keywords__delete-category--notice">
            {{ $t('page.admin-keywords.delete-keyword-notice') }}
          </div>
        </div>
      </template>
    </DeleteDialog>
  </div>
</template>

<script>
import BaseRoundButton from '@/components/base/BaseRoundButton';
import DeleteDialog from '@/components/page-admin-keywords/DeleteDialog';
import Keyword from '@/components/page-keywords/Keyword';
import { mapActions } from 'vuex';

export default {
  name: 'KeywordsStatusManager',
  components: {
    BaseRoundButton,
    DeleteDialog,
    Keyword,
  },
  props: {
    keywords: {
      type: Array,
      required: true,
      default: () => [],
    },

    categoryId: {
      type: String,
    },
    // Without its button, the parent opens the confirmation (onDeleteKeywords).
    hasButton: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    ...mapActions('keywords', ['deleteKeywordsBulk']),
    onDeleteKeywords() {
      this.$refs.deleteKeywordsDialog.openDialog();
    },
    deleteKeywords() {
      let ids = [];
      this.keywords.forEach((kw) => ids.push(kw.id));

      const message = this.$tc('page.admin-keywords.delete-keywords-success');

      this.deleteKeywordsBulk(ids)
        .then(() => this.$toast.success(message))
        .catch((error) => this.$toast.error(error));
      this.$emit('keywords-status-updated');
    },
    onRefresh() {
      this.getKeywords();
    },
  },
};
</script>

<style lang="scss">
.keywords-status-manager {
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  background-color: $color-white;
  border-radius: $border-radius-large;
  box-shadow: $shadow-dropdown, $shadow-default;
  font-size: $font-size-small;
  padding: 6px 14px 6px 54px;
  left: 30px;
  top: 12px !important;

  @media screen and (min-width: 1000px) {
    left: 2px;
    top: 4px;
    z-index: -1;
  }

  &__delete-list {
    padding: 16px 0px;
    overflow-y: auto;
    max-height: 260px;
    margin-bottom: 16px;
    height: auto;
  }
}
</style>
